import React, { useRef, useState } from "react";
import "../style/gcardStyle.css";
import { useTranslation } from "react-i18next";
import GcardForm from "../forms/GcardForm";
import { FcGoogle } from "react-icons/fc";
import { Link } from "react-router-dom";
import { Button, Input, message } from "antd";
const AddGcard = () => {
  const { t } = useTranslation();
  const cardUrlRef = useRef(null);
  const [placeId, setPlaceId] = useState("");
  

  // const handelGetNFCLink = (value)=>{
  //   setPlaceId(value);
  //   console.log("placeId=",placeId)
  // }
  const handelCopyCardUrl = () => {
    const inputElement = cardUrlRef.current.input;
    if (inputElement) {
      const valueToCopy = inputElement.value;
      navigator.clipboard
        .writeText(valueToCopy)
        .then(() => {
          message.success(t("Copied to clipboard!"));
        })
        .catch(() => {
          inputElement.select();
          message.execCommand("copy");
          message.success(t("Copied to clipboard!"));
        });
    }
  };
  return (
    <div className="add_google_card p-2">
      <h3 className="text-center">
        {" "}
        <FcGoogle /> {t("HEADING.ADDGCARDTITLE")}{" "}
      </h3>
      <div className="google_placeid_nfcurl mb-3">
        <Link
          to="https://developers.google.com/maps/documentation/javascript/examples/places-placeid-finder"
          target="_blank"
          className="link_place_id"
        >
        {t("BUTTONS.GETPLACEID")}
        </Link>
        <div className="d-flex flex-row flex-wrap justify-content-between">
            <div className="placid_value d-flex flex-row flex-wrap gap-3 my-2">
              <Input
                placeholder="place id"
                style={{ height: 45 }}
                 value={placeId}
                onChange={(e) => setPlaceId(e.target.value)}
              />
          </div>
          {
            placeId !=="" ?(
            <div className="copy_nfc_url mt-1 d-flex flex-wrap gap-3">
              <Input
                ref={cardUrlRef}
                value={`https://search.google.com/local/writereview?placeid=${placeId}`}
                disabled
              />
              <Button
                type="primary"
                className="px-5 fw-bold fs-5"
                style={{ height: 50 }}
                onClick={handelCopyCardUrl}
              >
                {t("BUTTONS.COPYNFCURL")}
              </Button>
              </div>
            ):null
          }
          
        </div>
      </div>
      <GcardForm translate={t} />
    </div>
  );
};

export default AddGcard;
